"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var deprecatedProps = {
  /** DEPRECATED: Use "labelW" instead */
  labelWidth: _propTypes["default"].string,
  /** DEPRECATED: Use "inputW" instead */
  inputWidth: _propTypes["default"].string,
  /** DEPRECATED: Use "w" instead */
  width: _propTypes["default"].string,
  /** DEPRECATED: Margin bottom for the field wrapper */
  marginBottom: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string])
};
var _default = exports["default"] = deprecatedProps;